import React, { useState } from "react";
import { ArrowRight, FolderPlus, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import { DocumentPicker } from "../components/practices/DocumentPicker";
import { practiceApi } from "../lib/practiceApi";
import { RelationInputs } from "../components/practices/PracticeRelations";
import "../components/practices/practices.css";

export default function PracticeImportPage({ practices, clients, sites, onOpen, onChanged }) {
  const [relations, setRelations] = useState({});
  const [files, setFiles] = useState([]);
  const [target, setTarget] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState("");
  const [error, setError] = useState("");
  async function submit(e) {
    e.preventDefault(); setBusy(true); setError("");
    let id = target;
    try {
      if (!id) {
        const result = await practiceApi("/practices/dossier", { method: "POST", body: JSON.stringify({ data: { ...(name.trim() && { name }), ...relations } }) });
        id = result.practice.id; setTarget(id);
        onChanged();
      }
      const failed = [], errors = [];
      for (let i = 0; i < files.length; i++) {
        setProgress(`Salvataggio ${i + 1} di ${files.length}: ${files[i].name}`);
        const body = new FormData(); body.append("file", files[i]);
        try { await practiceApi(`/practices/${id}/documents`, { method: "POST", body }); }
        catch (err) { failed.push(files[i]); errors.push(`${files[i].name}: ${err.message}`); }
      }
      setFiles(failed);
      if (failed.length) setError(errors.join(" · "));
      else onOpen(id);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); setProgress(""); onChanged(); }
  }
  return <section className="practice-workspace practice-import" data-testid="practice-import-page">
    <div className="practice-section-heading"><div><span className="practice-kicker"><Sparkles size={15} /> DOCUMENTI → PRATICA</span><h2>Un unico fascicolo, tutti i documenti</h2></div><FolderPlus size={30} color="var(--wine)" /></div>
    <form onSubmit={submit}>
      <div className="practice-form-grid">
        <label>Destinazione<select data-testid="ai-target-practice" value={target} disabled={busy} onChange={e => setTarget(e.target.value)}><option value="">Crea una nuova pratica</option>{target && !practices.some(p => p.id === target) && <option value={target}>Pratica appena creata</option>}{practices.map(p => <option key={p.id} value={p.id}>{p.name || "Pratica da completare"}</option>)}</select></label>
        {!target && <label>Titolo pratica <small>facoltativo</small><input data-testid="ai-practice-name" value={name} onChange={e => setName(e.target.value)} placeholder="Da compilare con AI" disabled={busy} /></label>}
      </div>
      <DocumentPicker files={files} setFiles={setFiles} disabled={busy} prefix="ai" />
      {!target && <RelationInputs value={relations} onChange={setRelations} clients={clients} sites={sites} prefix="ai-import" disabled={busy} />}
      {progress && <p className="practice-notice" role="status" data-testid="ai-upload-progress">{progress}</p>}
      {error && <div className="error" role="alert" data-testid="ai-import-error">{error}</div>}
      <div className="practice-action-bar"><span className="muted" data-testid="ai-upload-count">{files.length} documenti selezionati</span><Button type="submit" className="primary" data-testid="ai-create-practice-button" disabled={busy || !files.length}>{busy ? "Salvataggio…" : target ? "Aggiungi alla pratica" : "Crea pratica e analizza"}<ArrowRight size={16} /></Button></div>
      {target && !busy && <Button variant="ghost" type="button" data-testid="ai-open-target-practice" onClick={() => onOpen(target)}>Apri il fascicolo <ArrowRight size={16} /></Button>}
    </form>
  </section>;
}